module.exports = __webpack_public_path__ + "static/google-e9612850a6cb55eb547266043e1eef86.png";